<template>
    <div class="count-container broker">
        <div class="bed-count" v-if="countInfo.bedrooms">
            <p class="count-logo iconfont icon-bed"></p>
            <p class="desc">
                <span class="number">{{
                    countInfo.bedrooms.num
                }}</span>
                <span class="house">{{ countInfo.bedrooms.unit }}</span>
            </p>
        </div>
        <div class="bath-count" v-if="countInfo.bathrooms">
            <p class="count-logo iconfont icon-bath"></p>
            <p class="desc">
                <span class="number">{{
                    countInfo.bathrooms.num
                }}</span>
                <span class="house">{{
                    countInfo.bathrooms.unit
                }}</span>
            </p>
        </div>
        <div
            class="sqft-count"
            v-if="countInfo.sqft"
        >
            <p class="count-logo iconfont icon-SqFt"></p>
            <p class="desc">
                <span class="number">{{
                    countInfo.sqft.num
                }}</span>
                <span class="house">{{
                    countInfo.sqft.unit
                }}</span>
            </p>
        </div>
    </div>
</template>
<script>
import { mapState } from '@/store/helpers';
import { getCountObj } from '../../info-header-count.js';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['filling'],
    data: function() {
        return {};
    },
    computed: {
        ...mapState({
            'info': store => store.listingDetail.info || {}
        }),
        countInfo({ info }) {
            return getCountObj.call(this, info);
        }
    }
};
</script>
<style lang="scss">
.count-container.broker {
    display: flex;
    margin-left: 20px;
    div {
        display: inline-flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: center;
        position: relative;
        &:after {
            position: absolute;
            content: '';
            width: 1px;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.1);
            right: -1px;
            top: 0;
        }
        &:first-child {
            padding-left: 0;
        }
        &:last-child {
            padding-right: 0;
            &:after {
                display: none;
            }
        }
        &.sqft-count {
            margin-right: 0px;
        }
        > p {
            &.count-logo {
                width: 20px;
                height: 20px;
                position: relative;
                margin-bottom: 10px;
            }
            &.icon-bed,
            &.icon-bath,
            &.icon-SqFt {
                font-size: 20px;
                &:before {
                    color: #505050;
                    position: absolute;
                    transform: translate(-50%, -50%);
                    top: 50%;
                    left: 50%;
                }
            }
        }
        .desc {
            line-height: 18px;
            font-size: 14px;
            color: #505050;
            text-align: center;
            display: flex;
            align-items: baseline;
            .number {
                font-family: var(--font-bold);
            }
            .house {
                font-family: var(--font-normal);
                margin-left: 5px;
                font-size: 12px;
            }
        }
    }
}
@media (max-width: 600px) {
    .count-container.broker {
        float: none;
        display: flex;
        margin: 0;
        font-size: 0; // remove the gap
        div {
            margin: 0;
            padding: 0 20px;
            &:first-child {
                padding-left: 0;
            }
            &.bed-count {
                padding-bottom: 0;
            }
            &.bed-count,
            &.bath-count {
                border-right: solid 1px #e2e4ea;
            }
            > p {
                &.count-logo {
                    margin-right: 0;
                    margin-bottom: 5px;
                    font-size: 16px;
                }
                .number {
                    font-size: 12px;
                }
                .house {
                    font-size: 12px;
                    padding-top: 0px;
                }
            }
            .desc {
                display: block;
            }
        }
    }
}
</style>
